/** Information of an integration */

/** State of the project-level integration dialog */

/** State of the user-level integration dialog */

/** Callbacks for the integration dialogs  */

/** Props for the integration dialogs */

/** Component or page from where the user=level integration connection is triggered */
export let IntegrationUserConnectionOrigin = /*#__PURE__*/function (IntegrationUserConnectionOrigin) {
  IntegrationUserConnectionOrigin["integrationAccounts"] = "integration accounts page";
  IntegrationUserConnectionOrigin["projectIntegrations"] = "project integrations page";
  return IntegrationUserConnectionOrigin;
}({});